// @flow

import * as types from '../actionTypes';
import genericNestedReducer, {
  genericNestedSelectorSet,
  useGenericNested,
} from './genericNested';
import type { transactionLandType } from '../../types';
import { saleLand } from '../schemata';

const saleLands = genericNestedReducer(types.GET_SALELAND_ASYNC);

export default saleLands;

export const selectsaleLands = genericNestedSelectorSet<transactionLandType>(
  saleLand,
  state => state.saleLands,
);

export const useSaleLands = {
  ...useGenericNested<transactionLandType>(
    saleLand,
    state => state.saleLands,
    state => state.sales,
  ),
  singleById: () => {
    throw new Error('This should not be used.');
  },
  metaSingleById: () => {
    throw new Error('This should not be used.');
  },
};
